abstract class AnalyticsEvent {
  public readonly name: string
  public properties: Record<string, unknown>

  protected constructor(
    name: string,
    properties: Record<string, unknown> = {},
  ) {
    this.name = name
    this.properties = properties
  }

  public setProperty(key: string, value: unknown) {
    this.properties[key] = value
  }
}

export { AnalyticsEvent }
